import React from "react";
import useQuestion from "../hooks/useQuestion";

import Answer from "./Answer";

const Question = ({
  questionID,
  shuffleAnswers,
  showAnswers,
  showNumbers,
  onPrevious,
  onNext,
  onReset,
  onFinish,
  finished,
}) => {
  const { question, image, answers } = useQuestion({
    questionID,
    shuffleAnswers,
  });

  const formattedQuestion = (() => {
    let numberString =
      question.number && showNumbers ? `${question.number}.` : "";
    let questionString = question.question ? `${question.question}:` : "";
    return (
      <>
        {numberString} {questionString}
      </>
    );
  })();

  return (
    <main>
      <div className="container-fluid mb-5">
        <div className="row row-cols-1 row-cols-sm-2">
          <div className="col-12 col-sm-12 order-1">
            {question.category} &mdash; {question.topic}.
          </div>
          <div className="col-12 col-sm-12 order-2">
            <hr />
          </div>
          {image && (
            <div className="col order-3 order-sm-4 text-center">
              <img
                className="img-fluid img-thumbnail w-100"
                src={image}
                alt="diagram"
              />
            </div>
          )}
          <div className="col order-4 order-sm-3">{formattedQuestion}</div>
        </div>
        <div className="list-group list-group-flush">
          {answers.map(([key, value]) => (
            <Answer
              key={key}
              questionID={questionID}
              number={value.number}
              text={value.answer}
              showAnswers={showAnswers}
              showNumbers={showNumbers}
              finished={finished}
            />
          ))}
        </div>
      </div>
      <div className="fixed-bottom bg-white">
        <div className="row g-0">
          {onPrevious && (
            <div className="col  d-grid gap-2">
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={onPrevious}
              >
                Previous
              </button>
            </div>
          )}
          {onReset && (
            <div className="col d-grid gap-2">
              <button
                className="btn btn-outline-danger"
                type="button"
                onClick={onReset}
              >
                Reset Answer
              </button>
            </div>
          )}
          {onNext && (
            <div className="col d-grid gap-2">
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={onNext}
              >
                Next
              </button>
            </div>
          )}
          {onFinish && (
            <div className="col d-grid gap-2">
              <button
                className="btn btn-outline-danger"
                type="button"
                onClick={onFinish}
              >
                Finish
              </button>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default Question;
